

<ng-container *ngTemplateOutlet="primaryTemplate()"></ng-container>

  <ng-template #templatelist id="templatelist">
  <div class="wm-form-row select-template-row">
    <div class="title-row bordered">
      <div *ngIf="isPrefabType">
        <label class="control-label col-xs-3">{{locale.LABEL_CHOOSE_PLATFORM_TYPE}}:</label>
        <div class="btn-group select-template-btn-group col-xs-6 ">
          <button name="template-web-button" type="button" class="select-template-btn" [ngClass]="isWeb ? 'btn btn-primary' : 'btn btn-tertiary template-btn-white'"
                  (click)="fetchTemplates(true)">Web<i class="wms wms-web"></i></button>
          <button name="template-mobile-button" type="button" class="select-template-btn" [ngClass]="isMobile ? 'btn btn-primary' : 'btn btn-tertiary template-btn-white'"
                  (click)="fetchTemplates(false)">Mobile<i class="wms wms-mobile"></i></button>
        </div>
      </div>
      <div *ngIf="newPage.type !== 'template' " wms-feature="workspace.templatebundle.import">
        <button type="button" class="btn btn-secondary pull-right import-btn" (click)="importTemplateBundleBtn($event)">{{ locale.LABEL_IMPORT_TEMPLATE}}</button>
      </div>
    </div>
    <wms-spinner *ngIf="loadingTemplates" id="templates-pane-spinner"></wms-spinner>
    <ul class="list-inline wm-tile-container padded-container wm-tile-list select-template-list {{platformType.toLowerCase()}} {{templatePlatformType.toLowerCase()}}">
      <li class="tile" title="{{template.name}}" *ngFor="let template of allTemplates| templateFilter:newPage.type:template.category:(newPage.type === 'template' ? false : true):template.search as searchResults " (click)="selectTemplateInLayout(template)"
          [ngClass]="{'active': template.active}" id="wm-template-{{template.id || 'blank'}}">
        <div class="wm-tile-thumbnail-ctr">
          <i class="wm-tile-thumbnail" id="wm-tile-thumbnail-{{template.id}}"
             [ngStyle]="{backgroundPosition: preDefinedTemplates[template.id]?.backgroundPosition, backgroundImage: template.thumbnail === '' ? '' : 'url(\'' + baseURL +'services/projects/' + projectService.getProjectId() + '/templatebundles/' + template.bundleId + '/versions/' + template.versionId + '/files/resources/' + template.id + '/' + template.thumbnail +  '\')'}"
             *ngIf="template.bundleId"></i>
        </div>
        <p id="wm-template-name-{{template.name}}" class="wm-tile-name">{{template.name === 'blank' ? template.description : template.name}}</p>
        <button type="button" class="wm-tile-preview" (click)="previewTemplateLayout($event, template);" *ngIf="template.screenshots?.length">
          <i class="wms wms-eye"></i>
          {{locale.LABEL_ADD_PAGE_SELECT_LAYOUT_PREVIEW}}
        </button>
      </li>
      <li class="no-results"  *ngIf="allTemplates && searchResults?.length == 0 && template.category.length && newPage.type === 'page'">
        {{locale.LABEL_NO_TEMPLATE_BUNDLE_MESSAGE}}
      </li>
    </ul>
  </div>
  </ng-template>



  <ng-template #newPageDlg id="newPageDlg">
    <div class="apply-template" style="padding:0px;">
      <div class="primary-panel full-height">
        <div class="full-height">
          <ul class="list-items" *ngIf="!(newPage.type === 'page' && stepCounter > 0) || isTemplateBundleType">
            <li class="list-item"
                (click)="$event.stopPropagation(); changeNewPageTypeFun(pageType);"
                *ngFor="let pageType of newPageTypes;let $index = index"
                id="{{ 'wm-page-type-' + pageType.type}}"
                [ngClass]="{'active': newPage.type === pageType.type, 'disabled': (templateData && templateData.template === 'template' && pageType.type !== 'template')}">
              <div class="item" title="{{locale[pageType.label]}}">
                <span class="title">{{locale[pageType.label]}}</span>
              </div>
            </li>
          </ul>
          <ul class="list-items" *ngIf="newPage?.type === 'page' && stepCounter > 0 && !isTemplateBundleType">
            <li class="list-item"
                (click)="  getSearchResults( category.key);"
                *ngFor="let  category of template.categories ;"
                id="{{ 'wm-template-category-' + tempCategory}}"
                [ngClass]="{'active': template.category === category.key}">
              <div class="item" title="{{category.label}}">
                <span class="title">{{category.label}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="secondary-panel full-height">
        <wms-message [scopeDataset]="fileAddMessage"></wms-message>
        <ng-template *ngTemplateOutlet="secondaryTemplate()"></ng-template>
      </div>
    </div>

  </ng-template>


    <ng-template #previewAndName id="previewAndName">
    <ng-container *ngIf="newPage.type !== 'template'">
    <div class="apply-template preview-name-section" [ngClass]="{'col-md-7': newPage.type === 'page' && stepCounter < 1}">
      <div class="name-section form-group">
        <label class="required control-label app-label">{{locale.LABEL_ADD_PAGE_NAME}}</label>
        <input type="text" name="wm-new-page-name" [(ngModel)]="newPage.name"
               autocomplete="off"
               ng-model-options="{updateOn:'blur change'}" [placeholder]="placeholder"
               class="app-textbox form-control" maxlength="32" autofocus required/>
      </div>

      <div class="wm-asset-ctr" *ngIf="newPage.type === 'page'">
        <i *ngIf="!isMobileApplicationType" class="wm-asset-tile wms-icon web-default-layout-icon"></i>
        <i *ngIf= "isMobileApplicationType" class="wm-asset-tile wms-icon {{pageLayout.activeLayout.id}}" [ngClass]="{'wms-mobile-layout': isMobileApplicationType, 'wms-web-layout': !isMobileApplicationType}"></i>
        <p class="wm-asset-title">{{pageLayout.activeLayout.description}}</p>
      </div>
      <div class="wm-tile-list wm-tile-thumbnail-ctr" *ngIf="newPage.type !== 'page'">
        <i class="wm-tile-thumbnail" id="wm-tile-thumbnail-{{template?.selected.id}}" [ngClass]="{'wm-tile-default-thumbnail': template?.selected.name === 'blank'}"
           [ngStyle]="{backgroundImage: template?.selected.thumbnail === '' ? '' : 'url(\'' + baseURL +'services/projects/' + projectService.getProjectId()+ '/templatebundles/' + template?.selected.bundleId + '/versions/' + template?.selected.versionId + '/files/resources/' + template?.selected.id + '/' + template?.selected.thumbnail +  '\')'}"></i>
        <p id="wm-template-name-{{template?.selected.name}}" class="wm-tile-name">{{ template?.selected.name === 'blank' ? template?.selected.description : template?.selected.name}}</p>
      </div>

    </div>
    <div class="apply-template note-section col-md-5" *ngIf="newPage.type === 'page' && stepCounter < 1">
      <p>{{locale.LABEL_NEW_PAGE_LAYOUT_HELP}}</p>
      <div class="wms-hint-change-layout-container">
        <i class="wm-asset-tile wms-icon wms-hint-change-layout"></i>
      </div>


    </div>
    </ng-container>
    <ng-container *ngIf="newPage.type === 'template'">
      <wms-message [scopeDataset]="fileAddMessage"></wms-message>
      <div class="wm-template-tile" *ngIf="newPage.type === 'template'">
        <h4>{{locale.LABEL_WIDGET_TEMPLATE}}</h4>
        <div class="text-muted">{{locale.MESSAGE_WIDGET_TEMPLATE}} <a target="_blank"
            href="https://www.wavemaker.com/learn/how-tos/custom-widget-template/">{{locale.MESSAGE_INFO_EXPORT_MODEL_HERE}}</a>
          {{locale.LABEL_FOR_MORE_INFO}}</div>
      </div>
      <div class="wm-form events-form variableTypeBlock">
        <div class="wms-block-title">
          <span title="{{locale.MESSAGE_SELECT_TEMPLATE_ENTITY}}"
            class="col-xs-12">{{locale.MESSAGE_SELECT_TEMPLATE_ENTITY}}</span>
        </div>
        <div class="category-section add-new-styles">
          <div class="form-group app-composite-widget col-md-4 clearfix">
            <label class="control-label app-label pageDialogueinput " [ngClass]="{'required': true}"
              title="{{locale['LABEL_ENTER_PAGE_NAME']}}">
              <span [innerHTML]="locale['LABEL_VARIABLE_PROPERTIES_PAGENAME']"></span>
            </label>
            <div class="form-control wms-typeahead-variables">
              <input type="text" name="wm-new-page-name" [(ngModel)]="newPage.name" autocomplete="off"
                ng-model-options="{updateOn:'blur change'}" [placeholder]="placeholder"
                class="app-textbox form-control" maxlength="32" autofocus required />
            </div>
    
          </div>
          <div class="form-group app-composite-widget col-md-4 clearfix">
            <label class="control-label app-label" [ngClass]="{'required': true}">
              {{locale.LABEL_SELECT_SERVICE}}
            </label>
            <div class="form-control wms-typeahead-variables">
              <wms-typeahead name="wm-addvariable-property-type"
                placeholder="{{locale.MESSAGE_PLACEHOLDER_SELECT_DATA_SOURCE}}" [model]="selectedDataSource"
                [options]="filteredDataSources" [disable]="createdVariable.propertyObj?.type?.disabled"
                (onSelect)="getServiceEntities($event)" (onClear)="clearServiceEntities()" propertyName="name"
                groupBy="displayType"></wms-typeahead>
            </div>
          </div>
          <div class="form-group app-composite-widget col-md-4 clearfix">
            <label class="control-label app-label pageDialogueinput" [ngClass]="{'required': true}"
              title="{{locale['LABEL_SELECT_TABLE']}}">
              <span [innerHTML]="locale['LABEL_SELECT_TABLE']"></span>
            </label>
            <div class="form-control wms-typeahead-variables">
              <!--          model-property-name="{{createdVariable.propertyObj['type'].modelPropertyName || (createdVariable.propertyObj['type'].groupBy ? '$key' : '$value')}}"-->
              <wms-typeahead name="wm-addvariable-property-type"
                placeholder="{{(locale['LABEL_SEARCH'] + ' ' + locale['LABEL_SELECT_TABLE'])}}"
                [options]="createdVariable.propertyObj?.type?.options"
                [model]="createdVariable.propertyObj?.type?.selectedOption"
                (onSelect)="onVariablePropertyChangefun('type', $event)"
                [propertyName]="createdVariable.propertyObj?.type?.propertyName" groupBy="displayType"
                [disable]="createdVariable.propertyObj?.type?.disabled"
                (onClear)="onVariablePropertyChangefun('type', {'$key': '', '$value': '' })">
              </wms-typeahead>
            </div>
          </div>
        </div>
        <div *ngIf="preDefinedTemplateSelected">
          <p class="section-title header">{{locale['LABEL_WIDGETS']}}</p>
          <div class="widget-map-container list-fields">
            <div class="col-xs-3 widgets-list full-height">
              <ul class="list-items">
                <li class="list-item" *ngFor=" let widget of templateWidgets" id="wm-live-list-widget-{{widget.name}}"
                  (click)="selectTemplateWidgetFun(widget)" [ngClass]="{'active': selectedWidget === widget}">
                  <div class="item">
                    <span class="title">{{widget.name + (widget.aspectRatio || '')}}</span>
                    <span class="validation-icon done pull-right" [hidden]="!widget.hasBinding"></span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-xs-9 prop-list full-height">
              <div class="col-xs-7 full-height">
                <div>
                  <div class="section-title">{{selectedWidget.name + ' ' + locale['LABEL_WIDGET']}}</div>
                </div>
                <div widget="select" *ngFor="let prop of selectedWidget.widgetProps;">
                  <label class="col-xs-3" [innerHTML]="locale['LABEL_PROPERTY_' + prop.name.toUpperCase()]"></label>
                  <select class="app-select form-control" name="wm-live-list-prop-{{prop.name}}" [(ngModel)]="prop.field"
                    (change)="setWidgetProps(prop)">
                    <option [value]="null"></option>
                    <option *ngFor="let item of fields;" [value]="item.field">{{item.field}}</option>
                  </select>
                  <i placement="right" [tooltipAppendToBody]="true"
                    [tooltip]="locale['MESSAGE_HELP_PROPERTY_' + prop.name.toUpperCase()]" class="wm-icon wms wms-help"></i>
                </div>
              </div>
              <div class="col-xs-5 widget-screenshot text-center full-height">
                <span class="helper"></span><img [src]="listImage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    </ng-template>

  <ng-template #selectLayout id="selectLayout">
    <div class="wm-tile-preview-popup"*ngIf="showTemplatePreview" [hidden]="!showTemplatePreview">
    <div class="wm-carousel-container" *ngIf="showTemplatePreview">
      <carousel active="0" [interval]="carouselInterval" no-wrap="noWrapSlides">
        <slide *ngFor="let screenshot of template.preview.screenshots;" index="$index">
          <img ngSrc="{{baseURL + 'services/projects/' + projectService.getProjectId() + '/templatebundles/' + template.preview.bundleId + '/files/resources/' + template.preview.id + '/' + screenshot}}">
        </slide>
      </carousel>
    </div>
    <div class="tile-info">

      <label class="h3 text-whie" [innerText]="template.preview.name"></label>
      <p>{{template.preview.description}}</p>
    </div>
    <button type="button" class="close-btn" (click)="ctrlScope.showTemplatePreview = false;">
      <i class="wms wms-clear"></i>
    </button>
  </div>
  </ng-template>

  <ng-template #selectTemplateLayout id="selectTemplateLayout">
    <div class="apply-template">
      <ng-template [ngTemplateOutlet]="templatelist"></ng-template>
      <ng-template [ngTemplateOutlet]="selectLayout"></ng-template>
    </div>

  </ng-template>

<ng-template id="layoutOptions" #layoutOptions>
  <ul>
    <li (click)="selectedLayout(layout);" class="layout-ctr" id="wm-page-layout-{{layout.id}}" *ngFor=" let layout of layouts" [ngClass]="{'mobile': isMobileApplicationType}">
      <div class="wm-asset-ctr">
        <i class="wm-asset-tile wms-icon {{layout.id}}" [ngClass]="{'active': layout.id == activeLayout?.id, 'wms-mobile-layout': isMobileApplicationType, 'wms-web-layout': !isMobileApplicationType}"></i>
        <p class="wm-asset-title">{{layout.description}}</p>
      </div>
    </li>
  </ul>
</ng-template>


